import { makeStyles } from "@material-ui/core"
import { colors } from "@/styles/colors"
import ColorUtil from "@/utils/ColorUtil"

const useStyles = makeStyles({
	tabs: {
		position: "relative",
		"&::before": {
			content: "close-quote",
			position: "absolute",
			width: "100%",
			height: "1px",
			bottom: 0,
			left: 0,
			...ColorUtil.getBackgroundAndContrastColor(colors.gray[200])
		}
	},
	tabIndicator: {
		...ColorUtil.getBackgroundAndContrastColor(colors.purple[600])
	},
	tab: {
		color: `${colors.gray[400]} !important`,
		opacity: 1,
		fontSize: 14
	},
	configCard: {
		border: "1px solid #ece8f3",
		borderRadius: "12px",
		padding: "18px 20px",
		backgroundColor: "#fff"
	},
	configCardSpacing: {
		marginTop: "14px"
	},
	cardHeader: {
		display: "flex",
		alignItems: "flex-start",
		gap: "16px"
	},
	cardHeaderText: {
		display: "flex",
		flexDirection: "column",
		gap: "4px",
		flex: 1,
		minWidth: 0
	},
	switchRoot: {
		padding: 0,
		margin: 0
	},
	switchTrack: {
		borderRadius: "13px",
		height: "24px",
		width: "42px",
		backgroundColor: "#d6d0e2"
	},
	switchThumb: {
		width: 18,
		height: 18,
		boxShadow: "none",
		backgroundColor: "#fff"
	},
	switchBase: {
		top: "3px",
		left: "3px",
		padding: 0,
		"&$switchBaseChecked + $switchTrack": {
			backgroundColor: "#6c4cf1",
			opacity: 1
		}
	},
	switchBaseChecked: {
		transform: "translateX(18px)"
	},
	warningBanner: {
		display: "flex",
		alignItems: "flex-start",
		gap: "10px",
		backgroundColor: "#fdf6e0",
		borderRadius: "10px",
		padding: "12px 14px",
		marginTop: "16px"
	},
	warningBannerFilas: {
		marginTop: "14px",
		padding: "11px 13px",
		gap: "8px"
	},
	warningBannerDigitando: {
		marginTop: "14px"
	},
	warningIcon: {
		color: "#c99700",
		fontSize: "16px",
		marginTop: "1px",
		flex: "none"
	},
	sliderRow: {
		display: "flex",
		alignItems: "center",
		gap: "14px",
		marginTop: "16px"
	},
	slider: {
		flex: 1,
		color: "#6c4cf1",
		"& .MuiSlider-rail": {
			height: "6px",
			borderRadius: "3px",
			backgroundColor: "#ece8f3"
		},
		"& .MuiSlider-track": {
			height: "6px",
			borderRadius: "3px"
		},
		"& .MuiSlider-thumb": {
			width: 18,
			height: 18,
			marginLeft: "-9px",
			marginTop: "-6px",
			boxShadow: "none",
			backgroundColor: "#6c4cf1"
		}
	},
	sliderValueBadge: {
		minWidth: "52px",
		textAlign: "center",
		padding: "6px 8px",
		borderRadius: "8px",
		backgroundColor: "#efe9fb",
		flex: "none"
	},
	bulletsList: {
		margin: "14px 0 0",
		paddingLeft: "18px",
		display: "flex",
		flexDirection: "column",
		gap: "6px"
	},
	dialogContent: {
		"&&": {
			maxHeight: "min(640px, calc(100vh - 220px))",
			overflowY: "auto"
		}
	}
})

export default useStyles
